import { Component, type ReactNode } from 'react';

type Props = { children: ReactNode; fallback?: ReactNode };
type State = { err: Error | null };

export class ErrorBoundary extends Component<Props, State> {
  state: State = { err: null };

  static getDerivedStateFromError(err: Error): State {
    return { err };
  }

  componentDidCatch(err: Error, info: unknown) {
    console.error('ErrorBoundary caught:', err, info);
  }

  reset = () => this.setState({ err: null });

  render() {
    if (this.state.err) {
      return this.props.fallback ?? (
        <main className="min-h-full grid place-items-center p-6">
          <div className="max-w-md rounded-2xl bg-rose-950/60 ring-1 ring-rose-400/30 p-6 text-slate-100">
            <div className="text-sm text-rose-300 uppercase tracking-wider mb-2">Unexpected error</div>
            <div className="font-semibold mb-2">Something rendered badly on this page.</div>
            <div className="text-xs text-slate-400 mb-4 break-all">{this.state.err.message}</div>
            <div className="flex gap-2">
              <button onClick={this.reset} className="rounded-lg bg-sky-500 hover:bg-sky-400 text-slate-950 px-3 py-2 text-sm font-semibold">
                Retry
              </button>
              <button onClick={() => window.location.reload()} className="rounded-lg bg-slate-800 hover:bg-slate-700 text-slate-100 ring-1 ring-white/10 px-3 py-2 text-sm">
                Reload page
              </button>
            </div>
          </div>
        </main>
      );
    }
    return this.props.children;
  }
}
